import React, { useContext, Fragment, useState, useEffect } from "react";
import { Context } from "../store/AppContext";
import "../../styles/Login.css";
import Recuperar from "../component/Login/Recuperar";
import Bienvenida from "../component/Login/Bienvenida";
import FormularioLogin from "../component/Login/FormularioLogin";

export const Login = () => {
	const { store } = useContext(Context);
	const [bienvenida, setBienvenida] = useState(false);
	const [recuperarClave, setRecuperarClave] = useState(false);
	const [verificandoSesion, setVerificandoSesion] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			const expirationTime = localStorage.getItem("sessionExpiration");
			const currentTime = new Date().getTime();
			const sesionValida =
				expirationTime && currentTime <= parseInt(expirationTime);

			if (
				sesionValida &&
				store.usuarioActual != null &&
				store.token != null &&
				store.usuarioActual.nombre != null &&
				typeof store.usuarioActual.nombre === "string"
			) {
				setBienvenida(true);
			}
			setVerificandoSesion(false);
		}, 100);

		return () => clearTimeout(timer);
	}, [store.usuarioActual, store.token]);

	return (
		<Fragment>
			{verificandoSesion ? (
				<div className='login-container'>
					<div className='login-loading'>
						<div className='login-loading-spinner' aria-hidden='true' />
						<span>Verificando sesión…</span>
					</div>
				</div>
			) : (
				<>
					{bienvenida ? <Bienvenida /> : null}
					{recuperarClave ? (
						<Recuperar setRecuperarClave={setRecuperarClave} />
					) : null}
					{!bienvenida && !recuperarClave ? (
						<div className='login-container'>
							<FormularioLogin setBienvenida={setBienvenida} />
						</div>
					) : null}
				</>
			)}
		</Fragment>
	);
};
